import classNames from "classnames";
import PropTypes from "prop-types";

export const SmallPrint = ({ children, classes }) => {
  return <p className={classNames(classes, "SmallPrint")}>{children}</p>;
};

SmallPrint.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.string,
};
